import { FormControl, FormHelperText, makeStyles, MenuItem, Select, Typography, TextField, Grid } from '@material-ui/core'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers'
import React, { useState, useEffect } from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { countrycodes, sortByName } from '../shared/constants'
import ChipInput from 'material-ui-chip-input'

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '100%',
      marginTop: '22px',
      fontSize: '16px',
    },
  },
  input: {
    width: '90%',
    fontSize: '16px',
    // marginTop: '16px',
  },
  fullWidth: {
    width: '100%',
  },
}))

const ShowImportant = ({ noValidate }) => {
  if (noValidate) return <></>
  return <span style={{ color: 'red' }}>*</span>
}

export function CustomSelect({
  handleChange,
  value,
  label,
  className,
  options,
  placeholder,
  setForm,
  form,
  name,
  disabled,
  errorMessage,
  onKeyDown,
  fieldName,
  fieldName2 = null,
  fieldValue,
  conditions = [],
  handleValidation = () => {},
  noValidate = false,
  onChange,
}) {
  const classes = useStyles()
  if (noValidate) handleValidation = () => {}

  const handleOnChange = (event) => {
    handleChange(event.target.value)
    handleValidation(event, conditions)
  }

  const handleChangeNew = (event) => {
      setForm({ ...form, [event.target.name]: event.target.value })
      handleValidation(event, conditions)
  }

  return (
    <div>
      <FormControl className={className ? `${className} ${classes.input}` : classes.input} style={{ marginTop: '22px' }}>
        <Typography style={{ fontWeight: 600, fontSize: '14px' }}>
          {label}
          <ShowImportant noValidate={noValidate} />
        </Typography>
        <Select
          name={name}
          onChange={onChange ? onChange : handleChange ? handleOnChange : handleChangeNew}
          value={value}
          // className={className ? `${className} ${classes.input}` : classes.input}
          disabled={disabled}
          InputLabelProps={{ shrink: false }}
          onBlur={(event) => handleValidation(event, conditions)}
          error={errorMessage ? true : false}
        >
          <MenuItem value="" disabled>
            {' '}
            <em>{placeholder ? placeholder : label}</em>{' '}
          </MenuItem>
          {options &&
            options.map((item, index) => (
              <MenuItem value={fieldValue ? item[fieldValue] : item} key={index}>
                {fieldName ? `${item[fieldName]} ${fieldName2 ? '/ ' + item[fieldName2] : ''}` : item}
              </MenuItem>
            ))}
        </Select>
        <FormHelperText style={{ color: 'red' }}>{errorMessage}</FormHelperText>
      </FormControl>
    </div>
  )
}

export function CustomDate({
  handleChange,
  value,
  label,
  className,
  setForm,
  form,
  name,
  disabled,
  shrink,
  errorMessage,
  maxDate,
  minDate,
  defaultVal,
  conditions = [],
  handleValidation = () => {},
  noValidate = false,
}) {
  const classes = useStyles()
  if (noValidate) handleValidation = () => {}

  const handleOnChange = (event) => {
    let changedDate = new Date(event).toISOString().slice(0, 10)
    handleChange(changedDate)
    handleValidation({ target: { name, value: changedDate } }, conditions)
  }

  const handleChangeNew = (event) => {
    console.log({event})
    if(event == 'Invalid Date') return;
    let changedDate = new Date(event).toISOString().slice(0, 10)
    setForm({ ...form, [name]: changedDate })
    handleValidation({ target: { name, value: changedDate } }, conditions)
  }

  return (
    <div>
      <FormControl className={className ? `${className} ${classes.input}` : classes.input} style={{ marginTop: '22px' }}>
        <Typography style={{ fontWeight: 600, fontSize: '14px' }}>
          {label}
          <ShowImportant noValidate={noValidate} />
        </Typography>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            // autoOk
            openTo="year"
            InputAdornmentProps={{ position: "start" }}
            // disableToolbar
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            name={name}
            onChange={handleChange ? handleOnChange : handleChangeNew}
            value={value}
            // className={className ? `${className} ${classes.input}` : classes.input}
            disabled={disabled}
            maxDate={maxDate}
            minDate={minDate}
            default={defaultVal}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            onYearChange = {()=>{ console.log("year")}}
            onMonthChange = {()=>{ console.log("month")}}
            onDateChange = {()=>{ console.log("date")}}
            // onBlur={(event) => handleValidation({ target: { name, value: event } }, conditions)}
            style={{ width: '90%', marginTop: '0px' }}
          />
        </MuiPickersUtilsProvider>
        <FormHelperText style={{ color: 'red' }}>{errorMessage}</FormHelperText>
      </FormControl>
    </div>
  )
}

export function CustomTime({ handleChange, value, label, className, setForm, form, name, errorMessage, conditions = [], handleValidation = () => {}, noValidate = false }) {
  const classes = useStyles()
  if (noValidate) handleValidation = () => {}

  const handleOnChange = (event) => {
    let changedDate = new Date(event).toISOString()
    handleChange(changedDate)
    handleValidation({ target: { name, value: changedDate } }, conditions)
  }

  const handleChangeNew = (event) => {
    console.log('EVENT : ', event)
    if(event === 'Invalid Date') return;
    let changedDate = new Date(event).toISOString()
    setForm({ ...form, [name]: changedDate })
    handleValidation({ target: { name, value: changedDate } }, conditions)
  }

  return (
    <div>
      <FormControl className={className ? `${className} ${classes.input}` : classes.input} style={{ marginTop: '22px' }}>
        <Typography style={{ fontWeight: 600, fontSize: '14px' }}>
          {label}
          <ShowImportant noValidate={noValidate} />
        </Typography>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          {/* <KeyboardTimePicker
            // disableToolbar
            variant="inline"
            margin="normal"
            name={name}
            onChange={handleChange ? handleOnChange : handleChangeNew}
            value={value}
            // className={className ? `${className} ${classes.input}` : classes.input}
            autoOk={true}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            onBlur={(event) => handleValidation({ target: { name, value: event } }, conditions)}
            style={{ width: '90%', marginTop: '0px' }}
          /> */}

          <KeyboardTimePicker
            margin="normal"
            id="time-picker"
            value={value}
            onChange={handleChange ? handleOnChange : handleChangeNew}
            KeyboardButtonProps={{
              'aria-label': 'change time',
            }}
          />
        </MuiPickersUtilsProvider>
        <FormHelperText style={{ color: 'red' }}>{errorMessage}</FormHelperText>
      </FormControl>
    </div>
  )
}

export function CustomInput({
  handleChange,
  value,
  label,
  className,
  setForm,
  form,
  name,
  disabled,
  errorMessage,
  type,
  conditions = [],
  handleValidation = () => {},
  noValidate = false,
  onChange,
  fullWidth,
}) {
  const classes = useStyles()
  if (noValidate) handleValidation = () => {}

  const handleCustomChange = (event) => {
    handleChange(event.target.value)
    handleValidation(event, conditions)
  }

  const handleFieldChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value })
    handleValidation(event, conditions)
  }

  return (
    <div>
      <FormControl className={className ? `${className} ${classes.input}` : classes.input} style={{ marginTop: '22px' }}>
        <Typography style={{ fontWeight: 600, fontSize: '14px' }}>
          {label}
          <ShowImportant noValidate={noValidate} />
        </Typography>
        <TextField
          value={value}
          name={name}
          onChange={onChange ? onChange : handleChange ? handleCustomChange : handleFieldChange}
          onBlur={(e) => handleValidation(e, conditions)}
          disabled={disabled}
          type={type ? type : 'text'}
          error={errorMessage ? true : false}
          inputProps={type === 'NUMBER' && { pattern: '[-+]?[0-9]*[.,]?[0-9]+' }}
          style={{ width: fullWidth ? '100%' : '90%' }}
          // style={{ marginTop: '16px' }}
        />
        <FormHelperText style={{ color: 'red' }}>{errorMessage}</FormHelperText>
      </FormControl>
    </div>
  )
}

export function CustomChipInput({
  handleChange,
  value,
  label,
  className,
  setForm,
  form,
  name,
  disabled,
  errorMessage,
  type,
  conditions = [],
  handleValidation = () => {},
  noValidate = false,
  fullWidth = false,
  questionType = 'MCQ',
  onChange,
  onDelete,
}) {
  const classes = useStyles()
  //console.log('questionType : ', questionType)
  return (
    <FormControl className={className ? `${className} ${classes.input}` : fullWidth ? `${classes.fullWidth} ${classes.input}` : classes.input} style={{ marginTop: '22px' }}>
      <Typography style={{ fontWeight: 600, fontSize: '14px' }}>
        {label}
        <ShowImportant noValidate={noValidate} />
      </Typography>
      <ChipInput
        value={questionType === 'BOOLEAN' ? ['True', 'False'] : value}
        onAdd={onChange ? onChange : (chip) => setForm({ ...form, [name]: [...value, chip] })}
        onDelete={
          questionType === 'BOOLEAN'
            ? null
            : onDelete
            ? onDelete
            : (chip, index) => {
                let arr = value
                arr = arr.filter((val, i) => index !== i)
                setForm({ ...value, [name]: [...arr] })
              }
        }
        onBlur={(e) => handleValidation(e, conditions)}
        // error={errorMessage ? true : false}
        // variant="outlined"
        // error={error.tags}
        // helperText={error.tags || t('Please press enter after each tag')}
        placeholder="Please press enter after each tag"
        fullWidth={fullWidth}
        disabled={disabled}
        name={name}
      />
    </FormControl>
  )
}

export function CustomMultiSelect({
  handleChange,
  value,
  label,
  className,
  options,
  placeholder,
  setForm,
  form,
  name,
  disabled,
  errorMessage,
  onKeyDown,
  fieldName,
  fieldName2 = null,
  fieldValue,
  conditions = [],
  handleValidation = () => {},
  noValidate = false,
}) {
  console.log('first1', fieldValue, options)
  const [selectedAll, setSelectedAll] = useState(false)

  const isExist = (item) => {
    return item && value && value?.indexOf(fieldValue ? item[fieldValue] : item) !== -1
  }

  let formValue = options.filter((item) => item && isExist(item))

  const classes = useStyles()
  if (noValidate) handleValidation = () => {}

  if (options && options.length && value && value?.length !== options.length) options = fieldName ? [{ [fieldName]: 'Select All' }, ...options] : ['Select All', ...options]

  const handleSelectChange = (e, values) => {
    // all options is selected or not
    let isAll = !values.every((item) => (fieldValue ? item[fieldValue] && item[fieldName] !== 'Select All' : item !== 'Select All'))

    isAll = isAll || values.length === options.length - 1
    let temp = [...options]
    // if all option is selected than remove first option as it is select all option
    temp = isAll ? temp.splice(1) : values

    sortByName(temp, fieldName)

    // for setting actual value, array of ids, fieldvalue
    let actualSelectedOptions = fieldValue ? temp.map((item) => item[fieldValue]) : temp
    console.log(actualSelectedOptions)
    handleChange ? handleChange(actualSelectedOptions) : setForm({ ...form, [name]: actualSelectedOptions })
    setSelectedAll(isAll)
    // handleValidation({ target: { value: actualSelectedOptions, name } }, conditions)
  }
  React.useEffect(() => {
    console.log(form[value])
  }, [form])
  return (
    <FormControl className={className ? `${className} ${classes.input}` : classes.input} style={{ marginTop: '22px', width: '97%' }}>
      <Typography style={{ fontWeight: 600, fontSize: '14px' }}>
        {label}
        <ShowImportant noValidate={noValidate} />
      </Typography>
      <Autocomplete
        multiple
        diabled={disabled}
        options={selectedAll ? options.slice(1).filter((item) => item && !isExist(item)) : options.filter((item) => item && !isExist(item))}
        getOptionLabel={(option) => (fieldName ? `${option[fieldName]}${fieldName2 && option[fieldName] !== 'Select All' ? '/' + option[fieldName2] : ''}` : option)}
        disableCloseOnSelect
        onChange={handleSelectChange}
        getOptionDisabled={(option) => option && isExist(option)}
        value={formValue}
        renderInput={(params) => <TextField {...params} variant="standard" placeholder={placeholder} fullWidth={true} />}
        //renderOption={(option)=><span disabled="true" >{option.name}</span>}
      />
      <FormHelperText style={{ color: 'red' }}>{errorMessage}</FormHelperText>
    </FormControl>
  )
}

export function CustomCountryCode({
  handleChange,
  value,
  label,
  className,
  setForm,
  form,
  name,
  disabled,
  errorMessage,
  type,
  conditions = [],
  handleValidation = () => {},
  noValidate = false,
  onChange,
  fullWidth,
}) {
  const classes = useStyles()
  if (noValidate) handleValidation = () => {}
  const [countryCode, setCountryCode] = useState("+91")
  console.log({value})

  const handleFieldChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value })
    handleValidation(event, conditions)
  }

  return (
    <div>
        <CustomSelect onChange = {handleFieldChange}
        fieldValue = "code"
        fieldName = "code"
        fieldName2 = "name"
        name = {name}
        form = {form}
        setForm = {setForm}
        value = {value}
        label = "Country Code" options = {countrycodes}/>
    </div>
  )
}
